// extracted by mini-css-extract-plugin
export default {"List":"About_List__LfM5z","ListItem":"About_ListItem__KkeIg","Me":"About_Me__3gIgI","AboutHeader":"About_AboutHeader__N71bz"};